import { render, staticRenderFns } from "./MainTable.vue?vue&type=template&id=279b8dbc&scoped=true&"
import script from "./MainTable.vue?vue&type=script&lang=js&"
export * from "./MainTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279b8dbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('279b8dbc')) {
      api.createRecord('279b8dbc', component.options)
    } else {
      api.reload('279b8dbc', component.options)
    }
    module.hot.accept("./MainTable.vue?vue&type=template&id=279b8dbc&scoped=true&", function () {
      api.rerender('279b8dbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/equipment/list/components/MainTable.vue"
export default component.exports